import { Button, Flex, Text } from '@chakra-ui/react';

import { DealType } from '../../../../gql/generated/graphql';
import { DealWithFarthestState } from '../../utils';

const WelcomeModalContent = ({
  deal,
  onClose,
}: {
  deal: DealWithFarthestState;
  onClose: () => void;
}) => {
  const isRefi = deal?.type === DealType.Refi;

  return (
    <Flex direction="column" textAlign="center" alignItems="center">
      <Text>
        This is it - the perfect place to check on your {isRefi ? 'refinance' : 'lease-end'}{' '}
        progress. As your Lease End Success Team continues working{' '}
        {isRefi ? 'on your new auto loan' : 'to end your lease'}, you'll see which stage you're in
        (and what comes next) here. Your team will be in touch if we need anything else from you. In
        the meantime, have a look around!
      </Text>
      <Button mt="20px" onClick={onClose} w="fit-content">
        OK
      </Button>
    </Flex>
  );
};

export default WelcomeModalContent;
